export enum EXMCaseStatusType {
  NONE = 'none',
  NORMAL = 'normal',
  DRAFT = 'draft',
  ACUTE = 'acute',
  UNCLEAR = 'unclear',
}
